<template>
  <div class="home-page" :style="{ paddingTop: gameContentTop }">
    <div style="position: relative"></div>

    <div class="domainModal_domainView__FWCzg" v-if="goInfo">
      <div class="domainModal_mask__24Y2m domainModal_fadeIn__1I3AS false" @click="goInfo = null"></div>
      <div class="domainModal_content__1nBgc" style="width: 80%">
        <img src="/static/image/hongbaocolse.png" @click="goInfo = null" style="position: absolute; top: 5px; right: 13px; width: 0.7rem" alt="" />
        <div class="domainModal_middle__3gQPm" style="padding: 35px 10px 15px">
          {{ goInfo }}
          <van-button type="info" style="margin: 0 auto; margin-top: 20px; width: 120px; border-radius: 10px; height: 35px" @click="$parent.goNav('/message')">{{ $t('More Announcements') }}</van-button>
        </div>
      </div>
    </div>

    <div class="xiding" ref="homeHeader">
      
      <div class="logo-wrapper">
        <img :src="siteLogo" :alt="siteTitle" class="logo-icon lu-logo woa-logo" @error="onLogoError">
        
        <!-- 原生手写：多语言地球切换按钮 (保证100%显示) -->
        <div class="lang-switch-btn" @click="showLangMenu = true">
          <!-- 地球 SVG 图标 -->
          <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="globe-icon"><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>
          <!-- 当前语言缩写 -->
          <span class="lang-text">{{ currentLangText }}</span>
        </div>
      </div>

      <div class="banner-wrapper" v-if="localBanners.length > 0">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" @change="onChange">
          <van-swipe-item v-for="(imgSrc, index) in localBanners" :key="index">
            <img :src="imgSrc" class="banner-img" />
          </van-swipe-item>
          <template #indicator>
            <div class="swiper-dots">
              <div class="num">{{ current + 1 }}</div>
              <div class="sign">/</div>
              <div class="num">{{ localBanners.length }}</div>
            </div>
          </template>
        </van-swipe>
      </div>

      <div class="caosuo">
        <div class="lefsg user-brief" v-if="$store.state.token" @click="$parent.goNav('/mine')">
          <img
            class="user-brief-avatar"
            :src="$store.state.userInfo.avatar || '/static/image/imageAvatar02@3x.png'"
            alt="avatar"
          />
          <div class="user-brief-meta">
            <div class="user-brief-top">
              <span class="user-brief-name">{{ displayUsername }}</span>
              <span class="user-brief-vip">VIP{{ displayVip }}</span>
            </div>
            <div class="user-brief-balance">
              <span>{{ currencySymbol }}{{ $store.getters.safeBalance | vnd }}</span>
              <div class="imsg" @click.stop="refreshBalance">
                <img :class="{ 'rotate': isRefreshing }" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAwUExURUdwTCUlJSgoKCkpKSgoKCkpKSkpKSkpKSoqKigoKCkpKScnJygoKCMjIygoKCoqKseuDdQAAAAPdFJOUwAQf+A/vplf7yDPL28fT1x7ifYAAADwSURBVCjPnVG7DgFRFLzeESKbKAiNKLQahUZWr6BCI0voUWvEDygkCo1S6R/4AJ/isesRIuO+F1GZYueeyZycOWcJ+Y10xXgv/V3A7rl1xAJDSws74FakSkbWXqBhkISFkxTyKDCKmdISwV1MWMDh7ENJOMPmmfMeZdlbFa/+WU0LoM1oelVCCGP69eCphDCOLDYOOiEe34KjfRyye+ropYXZuighiBrf9aZus8SAUVLoLKLNKarW9kJGtNDhM/rKGoc9pPUWYhWaZA3Uc016w5N7Q4aJqa86N1ltzLSF+DfZEe/NfP6/lEjmwrMi/+AFJYxumJPpNugAAAAASUVORK5CYII=" alt="reload" class="fit-image" />
              </div>
            </div>
          </div>
        </div>
        
        <!-- 更新后的登录注册按钮区域 -->
        <div v-else class="balance-wrapper">
          <div class="login-wrapper">
            <div class="regist-button button custom-reg-btn medium" @click="showRegister = true">
              {{ $t('Register') }}
            </div>
            <div id="login-button" class="button custom-login-btn medium" @click="showLogin = true">
              {{ $t('Login') }}
            </div>
          </div>
        </div>
       
        <div class="riggs">
          <div class="lisImg" @click="$parent.goNav('/recharge')">
            <div class="img-wrapper">
              <img src="/static/style/feature_moneydraw.cbeb513bc9fd00ecc5372fc0e54a84c0.png" alt="" />
              <div class="right-top-label" v-if="rechargeBonus > 0">{{ $t('Bonus percent', { n: rechargeBonus }) }}</div>
            </div>
            <div class="icon-text">{{ $t('Deposit') }}</div>
          </div>
          <div class="lisImg" @click="$parent.goNav('/withdrawal')">
            <img src="/static/style/feature_moneysave.4b60fbaf4ee368d1e7060133f62690c9.png" alt="" />
            <div class="icon-text">{{ $t('Withdraw') }}</div>
          </div>
          <div class="lisImg" @click="$parent.openKefu">
            <img src="/static/style/kffff.png" alt="" />
            <div class="icon-text">{{ $t('Customer Service') }}</div>
          </div>
          <div class="lisImg" @click="$parent.goNav('/hongbao')">
            <div class="link-icon rebate-icon pg-rebate-icon">
              <img src="/static/style/icon-profit-rain-dq3TXISv.png" alt="rebate" class="fit-image">
            </div>
            <div class="icon-text" style="color: rgb(250, 29, 29);"> {{ $t('Red Envelope Rain') }} </div>
          </div>
        </div>
      </div>

      <div class="top-tab-bar" v-if="gameType !== 6 && currentVendorTabs.length">
        <div class="game-type-tabs">
          <div
            v-if="showAllVendorTab"
            class="game-type-tab"
            :class="{ 'active': !selectedVendor }"
            @click="selectVendor('')"
          >{{ $t('All') }}</div>
          <div
            class="game-type-tab"
            v-for="tab in currentVendorTabs"
            :key="tab"
            :class="{ 'active': selectedVendor === tab }"
            @click="selectVendor(tab)"
          >{{ tab }}</div>
        </div>
        <div class="search-icon" @click="toggleSearchBox" v-if="gameType === 4">
          <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAwUExURUdwTCUlJSgoKCkpKSgoKCkpKSkpKSkpKSoqKigoKCkpKScnJygoKCMjIygoKCoqKseuDdQAAAAPdFJOUwAQf+A/vplf7yDPL28fT1x7ifYAAADwSURBVCjPnVG7DgFRFLzeESKbKAiNKLQahUZWr6BCI0voUWvEDygkCo1S6R/4AJ/isesRIuO+F1GZYueeyZycOWcJ+Y10xXgv/V3A7rl1xAJDSws74FakSkbWXqBhkISFkxTyKDCKmdISwV1MWMDh7ENJOMPmmfMeZdlbFa/+WU0LoM1oelVCCGP69eCphDCOLDYOOiEe34KjfRyye+ropYXZuighiBrf9aZus8SAUVLoLKLNKarW9kJGtNDhM/rKGoc9pPUWYhWaZA3Uc016w5N7Q4aJqa86N1ltzLSF+DfZEe/NfP6/lEjmwrMi/+AFJYxumJPpNugAAAAASUVORK5CYII=" alt="search" class="search-img">
        </div>
        <div class="search-box" v-if="showSearchBox && gameType === 4">
          <div class="search-input-wrapper">
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAwUExURUdwTCUlJSgoKCkpKSgoKCkpKSkpKSkpKSoqKigoKCkpKScnJygoKCMjIygoKCoqKseuDdQAAAAPdFJOUwAQf+A/vplf7yDPL28fT1x7ifYAAADwSURBVCjPnVG7DgFRFLzeESKbKAiNKLQahUZWr6BCI0voUWvEDygkCo1S6R/4AJ/isesRIuO+F1GZYueeyZycOWcJ+Y10xXgv/V3A7rl1xAJDSws74FakSkbWXqBhkISFkxTyKDCKmdISwV1MWMDh7ENJOMPmmfMeZdlbFa/+WU0LoM1oelVCCGP69eCphDCOLDYOOiEe34KjfRyye+ropYXZuighiBrf9aZus8SAUVLoLKLNKarW9kJGtNDhM/rKGoc9pPUWYhWaZA3Uc016w5N7Q4aJqa86N1ltzLSF+DfZEe/NfP6/lEjmwrMi/+AFJYxumJPpNugAAAAASUVORK5CYII=" alt="search" class="search-img-inside">
            <input type="text" v-model="searchKeyword" :placeholder="$t('Search Games')" class="search-input-with-icon">
          </div>
          <div class="search-close" @click="closeSearchBox">×</div>
        </div>
      </div>
    </div>

    <div class="gameBoxs">
      <div class="lfst" :style="{ top: sidebarStickyTop, maxHeight: sidebarMaxHeight }">
        <div :class="gameType == 6 ? 'ls active' : 'ls'" @click="changGameType(6)">
          <div class="side-icon-wrap">
            <img class="side-icon-img" src="/static/style/sidebar_hot.svg" alt="" />
          </div>
          <span>{{ $t('Hot') }}</span>
        </div>
        <div :class="gameType == 4 ? 'ls active' : 'ls'" @click="changGameType(4)">
          <div class="side-icon-wrap">
            <img class="side-icon-img" src="/static/style/sidebar_slots.svg" alt="" />
          </div>
          <span>{{ $t('Slots') }}</span>
        </div>
        <div :class="gameType == 0 ? 'ls active' : 'ls'" @click="changGameType(0)">
          <div class="side-icon-wrap">
            <img class="side-icon-img" src="/static/style/sidebar_livecasino.svg" alt="" />
          </div>
          <span>{{ $t('Live Casino') }}</span>
        </div>
        <div :class="gameType == 1 ? 'ls active' : 'ls'" @click="changGameType(1)">
          <div class="side-icon-wrap">
            <img class="side-icon-img" src="/static/style/sidebar_sports.svg" alt="" />
          </div>
          <span>{{ $t('Sports') }}</span>
        </div>
        <div :class="gameType == 2 ? 'ls active' : 'ls'" @click="changGameType(2)">
          <div class="side-icon-wrap">
            <img class="side-icon-img" src="/static/style/sidebar_fishing.svg" alt="" />
          </div>
          <span>{{ $t('Fishing') }}</span>
        </div>
        <div :class="gameType == 3 ? 'ls active' : 'ls'" @click="changGameType(3)">
          <div class="side-icon-wrap">
            <img class="side-icon-img" src="/static/style/sidebar_board.svg" alt="" />
          </div>
          <span>{{ $t('Board Games') }}</span>
        </div>
        <div :class="gameType == 5 ? 'ls active' : 'ls'" @click="changGameType(5)">
          <div class="side-icon-wrap">
            <img class="side-icon-img" src="/static/style/sidebar_lottery.svg" alt="" />
          </div>
          <span>{{ $t('Lottery') }}</span>
        </div>
      </div>

      <div class="content-area">
        <div class="rigts hot-grid" v-if="gameType == 6">
          <div class="game-item" v-for="(item, index) in displayedGames" :key="item.platform_name + '-' + item.game_code + '-' + index" @click="$parent.openGamePage(item.platform_name, item.game_code, '', getGameDisplayName(item, true))">
            <div class="game-icon-container">
              <img :src="getGameImg(item, 'fishing')" alt="" @load="onGameCoverLoad" @error="hideBrokenGameCover" />
              <div class="api-icon" v-if="apiLogoSrc(item)">
                <img :src="apiLogoSrc(item)" alt="" @error="hideBrokenApiIcon" />
              </div>
            </div>
            <div class="game-name">{{ getGameDisplayName(item) }}</div>
          </div>
        </div>
        <div class="rigts single-column realbet-content" v-if="gameType == 0">
          <div class="realbet-game-item" v-for="(item, index) in displayedGames" :key="index" @click="$parent.openGamePage(item.platform_name, item.game_code, '', item.name || item.game_name || item.title)">
            <div class="realbet-icon-container">
              <img :src="getGameImg(item, 'realbet')" alt="" />
            </div>
          </div>
        </div>
        <div class="rigts single-column sport-content" v-if="gameType == 1">
          <div class="sport-game-item" v-for="(item, index) in displayedGames" :key="index" @click="$parent.openGamePage(item.platform_name, item.game_code, '', item.name || item.game_name || item.title)">
            <div class="sport-icon-container">
              <img :src="getGameImg(item, 'sport')" alt="" />
            </div>
          </div>
        </div>
        <div class="rigts three-column" v-if="gameType == 2">
          <div class="game-item" v-for="(item, index) in displayedGames" :key="item.platform_name + '-' + item.game_code + '-' + index" @click="$parent.openGamePage(item.platform_name, item.game_code, '', getGameDisplayName(item, true))">
            <div class="game-icon-container">
              <img :src="getGameImg(item, 'gaming')" alt="" @load="onGameCoverLoad" @error="hideBrokenGameCover" />
              <div class="api-icon" v-if="apiLogoSrc(item)">
                <img :src="apiLogoSrc(item)" alt="" @error="hideBrokenApiIcon" />
              </div>
            </div>
            <div class="game-name">{{ getGameDisplayName(item) }}</div>
          </div>
        </div>
        <div class="rigts three-column" v-if="gameType == 3">
          <div class="game-item" v-for="(item, index) in displayedGames" :key="item.platform_name + '-' + item.game_code + '-' + index" @click="$parent.openGamePage(item.platform_name, item.game_code, '', getGameDisplayName(item, true))">
            <div class="game-icon-container">
              <img :src="getGameImg(item, 'joker')" alt="" @load="onGameCoverLoad" @error="hideBrokenGameCover" />
              <div class="api-icon" v-if="apiLogoSrc(item)">
                <img :src="apiLogoSrc(item)" alt="" @error="hideBrokenApiIcon" />
              </div>
            </div>
            <div class="game-name">{{ getGameDisplayName(item) }}</div>
          </div>
        </div>
        <div class="rigts three-column" v-if="gameType == 4">
          <div class="game-item" v-for="(item, index) in displayedGames" :key="item.platform_name + '-' + item.game_code + '-' + index" @click="$parent.openGamePage(item.platform_name, item.game_code, '', getGameDisplayName(item, true))">
            <div class="game-icon-container">
              <img :src="getGameImg(item, 'concise')" alt="" @load="onGameCoverLoad" @error="hideBrokenGameCover" />
              <div class="api-icon" v-if="apiLogoSrc(item)">
                <img :src="apiLogoSrc(item)" alt="" @error="hideBrokenApiIcon" />
              </div>
            </div>
            <div class="game-name">{{ getGameDisplayName(item) }}</div>
          </div>
        </div>
        <div class="rigts three-column" v-if="gameType == 5">
          <div class="game-item" v-for="(item, index) in displayedGames" :key="item.platform_name + '-' + item.game_code + '-' + index" @click="$parent.openGamePage(item.platform_name, item.game_code, '', getGameDisplayName(item, true))" :class="{ 'full-width': item.platform_name == 'vrbet' }">
            <div class="game-icon-container">
              <img :src="getGameImg(item, 'lottery')" alt="" @load="onGameCoverLoad" @error="hideBrokenGameCover" />
              <div class="api-icon" v-if="apiLogoSrc(item)">
                <img :src="apiLogoSrc(item)" alt="" @error="hideBrokenApiIcon" />
              </div>
            </div>
            <div class="game-name">{{ getGameDisplayName(item) }}</div>
          </div>
        </div>
      </div>
    </div>

    <van-popup v-model="leftshow" position="left" :style="{ height: '100%' }">
      <div class="leftbox">
        <div class="side__main__1NhyG">
          <h3>{{ $t('Welcome to') }}{{ $store.state.appInfo.title }}</h3>
          <dl class="side__vip__1dW8w">
            <div class="topxs">{{ $t('Exclusive VIP Experience') }}</div>
            <p>{{ $t('Enjoy member privileges') }}</p>
            <p>{{ $t('Enjoy uniqueness that belongs only to you') }}</p>
            <dd @click="$parent.goNav('/vip')">{{ $t('Member Center') }}</dd>
          </dl>
          <ul>
            <li v-if="$store.state.token" @click="$parent.goNav('/message')"><img src="/static/image/meunIcon.39f38dc98ad956615952d485d0e6af04.svg" />{{ $t('Message Center') }}<span class="side__subtitle__3QtYC"></span></li>
            <li @click="$parent.openKefu"><img src="/static/image/meunIcon2.5d0d78496889fb8b027f603254286fdf.svg" />{{ $t('Feedback') }}<span class="side__subtitle__3QtYC"></span></li>
            <li @click="doCopy($store.state.appInfo.h5_url)">
              <img src="/static/image/menuIcon5.5687ef4d1512d53aa3535e3b1088fe70.png" />{{ $t('Permanent Domain') }}<span class="side__subtitle__3QtYC">{{ $store.state.appInfo.h5_url }}</span>
            </li>
            <li @click="$parent.goNav('/abouts')"><img src="/static/image/meunIcon3.c51bbb9ebece978f1976397ab12acba7.svg" />{{ $t('About Us') }}<span class="side__subtitle__3QtYC"></span></li>
          </ul>
          <div class="nisd" v-if="!$store.state.token" @click="$parent.goNav('/login')">{{ $t('Login Now') }}</div>
          <div class="nisd" v-else @click="$parent.outLogin"><img src="/static/image/tuichu.93c1b9e3d4b4a7772481916ca32c074f.svg" />{{ $t('Safe Logout') }}</div>
        </div>
      </div>
    </van-popup>

    <div class="domainModal_domainView__FWCzg" v-if="$store.state.appInfo.index_modal == 1 && tanshow">
      <div class="domainModal_mask__24Y2m domainModal_fadeIn__1I3AS false" @click="changtanshow"></div>
      <div class="domainModal_content__1nBgc" style="width: 80%">
        <div id="domain" class="domainModal_contentTop__2C4jc">
          <img src="/static/image/hongbaocolse.png" @click="changtanshow" style="position: absolute; top: 5px; right: 13px; width: 0.6rem" alt="" />
          <div class="domainModal_middle__3gQPm" v-html="$store.state.appInfo.webcontent"></div>
        </div>
      </div>
    </div>
    
    <div class="login-modal-wrapper" v-if="showLogin">
      <div class="login-modal-overlay" @click="showLogin = false"></div>
      <div class="login-modal-content">
        <login @close="showLogin = false" @success="handleAuthSuccess"></login>
      </div>
    </div>
    <div class="login-modal-wrapper" v-if="showRegister">
      <div class="login-modal-overlay" @click="showRegister = false"></div>
      <div class="login-modal-content">
        <login @close="showRegister = false" :initial-type="1" @success="handleAuthSuccess"></login>
      </div>
    </div>

    <!-- 语言菜单底部弹窗 -->
    <van-popup v-model="showLangMenu" position="bottom" round>
      <div class="lang-menu-content">
        <div class="lang-title">{{ $t('Switch Language') }}</div>
        <div
          class="lang-item"
          v-for="item in languageOptions"
          :key="item.code"
          :class="{ active: $i18n.locale === item.code }"
          @click="changeLang(item.code)"
        >{{ item.label }}</div>
        <div class="lang-cancel" @click="showLangMenu = false">{{ $t('Cancel') }}</div>
      </div>
    </van-popup>

  </div>
</template>

<script>
import login from '../login.vue';
import languageselector from '../ui/languageselector.vue';
import defaultLogo from '@/assets/top-1-logo.png';
import { saveUserLanguage, LANGUAGE_OPTIONS, getLanguageShortName } from '@/utils/language';

const DEFAULT_BANNERS = [
  '/static/image/banner/1.jpg',
  '/static/image/banner/2.jpg',
  '/static/image/banner/3.jpg',
  '/static/image/banner/4.jpg',
];

export default {
  name: 'index',
  components: {
    login,
    languageselector,
  },
  data() {
    return {
      localBanners: DEFAULT_BANNERS.slice(),
      defaultLogo,
      logoFallback: false,
      hongbashow: true,
      current: 0,
      bannerList: [1], 
      homenoticelis: [],
      leftshow: false,
      activeKey: 0,
      gameType: 6,
      tanshow: true,
      goInfo: null,
      showLogin: false,
      showRegister: false,
      isRefreshing: false,
      isDragging: false,
      startX: 0,
      startY: 0,
      initialLeft: 0,
      initialTop: 0,
      showSearchBox: false,
      searchKeyword: '',
      selectedVendor: '',
      headerOffset: 0,
      
      showLangMenu: false, // 控制语言选择弹窗的显示
      languageOptions: LANGUAGE_OPTIONS,
    };
  },
  computed: {
    // 动态计算当前语言的简写文字
    currentLangText() {
      return getLanguageShortName(this.$i18n.locale);
    },
    gameContentTop() {
      if (this.headerOffset > 0) {
        return `${this.headerOffset}px`;
      }
      // 首屏测量前给一个偏大的兜底，避免左侧栏先顶到 banner 上再跳下来
      return `${7.2 + (this.gameType !== 6 && this.currentVendorTabs.length ? 1.0 : 0)}rem`;
    },
    sidebarStickyTop() {
      // sticky 相对视口：始终贴在固定头部下方，避免 fixed + 错误 top 导致“顶上去”
      if (this.headerOffset > 0) {
        return `${this.headerOffset + 4}px`;
      }
      return this.gameContentTop;
    },
    sidebarMaxHeight() {
      if (this.headerOffset > 0) {
        return `calc(100vh - ${this.headerOffset + 80}px)`;
      }
      return 'calc(100vh - 160px)';
    },
    displayUsername() {
      const u = this.$store.state.userInfo || {};
      return u.username || u.nickname || u.account || u.name || u.userid || u.user_id || u.id || '会员';
    },
    displayVip() {
      const u = this.$store.state.userInfo || {};
      if (u.vip !== undefined && u.vip !== null && u.vip !== '') return u.vip;
      if (u.current_vip) {
        const s = String(u.current_vip);
        const m = s.match(/(\d+)/);
        if (m) return m[1];
      }
      return 0;
    },
    // 后台充值赠送比例；0 不展示「送x%」
    rechargeBonus() {
      const n = Number(this.$store.state.appInfo && this.$store.state.appInfo.recharge_fee);
      if (!Number.isFinite(n) || n <= 0) return 0;
      return Number.isInteger(n) ? n : Number(n.toFixed(2));
    },
    siteTitle() {
      return (this.$store.state.appInfo && this.$store.state.appInfo.title) || 'Top-1';
    },
    siteLogo() {
      if (this.logoFallback) return this.defaultLogo;
      return (this.$store.state.appInfo && this.$store.state.appInfo.site_logo) || this.defaultLogo;
    },
    lotteryAllGames() {
      return [
        ...(this.$store.state.lhcList || []),
        ...(this.$store.state.jscList || []),
        ...(this.$store.state.jwcList || []),
        ...(this.$store.state.qkcList || []),
        ...(this.$store.state.lotteryList || [])
      ];
    },
    currentCategoryList() {
      const lists = {
        0: this.$store.state.realbetList,
        1: this.$store.state.sportList,
        2: this.$store.state.gamingList,
        3: this.$store.state.jokerList,
        4: this.$store.state.conciseList,
        5: this.lotteryAllGames,
        6: this.$store.state.fishingList
      };
      return lists[this.gameType] || [];
    },
    currentVendorTabs() {
      return this.getVendorTabs(this.currentCategoryList);
    },
    showAllVendorTab() {
      return this.currentVendorTabs.length > 1;
    },
    displayedGames() {
      const selected = this.normalizeVendorKey(this.selectedVendor);
      let list = this.currentCategoryList || [];
      if (selected) {
        list = list.filter(game => this.normalizeVendorKey(game.platform_name) === selected);
      }
      const keyword = (this.searchKeyword || '').toLowerCase().trim();
      if (this.showSearchBox && keyword) {
        list = list.filter((game) => {
          const gameName = (game.name || game.game_name || game.title || '').toLowerCase();
          const platformName = (game.platform_name || '').toLowerCase();
          const gameCode = (game.game_code || '').toLowerCase();
          return gameName.indexOf(keyword) !== -1
            || platformName.indexOf(keyword) !== -1
            || gameCode.indexOf(keyword) !== -1;
        });
      }
      return list.filter(game => !!this.getGameImg(game));
    }
  },
  watch: {
    '$store.state.appInfo.site_logo'() {
      this.logoFallback = false;
    },
    currentCategoryList() {
      this.ensureVendorSelection();
    }
  },
  created() {
    let that = this;
    that.getBanList();
    that.homenotice(); 
  },
  activated() {
    // 回到首页：未领取新人彩金则弹窗
    this.notifyAppCheckRegisterGift();
  },
  methods: {
    getAppVm() {
      // App 是根实例；中间隔着 Main，用 $root 最稳
      if (this.$root && typeof this.$root.checkRegisterGiftOnHome === 'function') {
        return this.$root;
      }
      let p = this.$parent;
      while (p) {
        if (typeof p.checkRegisterGiftOnHome === 'function' || typeof p.handleLoginSuccess === 'function') {
          return p;
        }
        p = p.$parent;
      }
      return null;
    },
    notifyAppCheckRegisterGift() {
      const app = this.getAppVm();
      if (app && typeof app.checkRegisterGiftOnHome === 'function') {
        app.checkRegisterGiftOnHome();
      }
    },
    handleAuthSuccess(payload) {
      this.showLogin = false;
      this.showRegister = false;
      const app = this.getAppVm();
      if (app && typeof app.handleLoginSuccess === 'function') {
        app.handleLoginSuccess(payload || {});
      }
    },
    onLogoError() {
      this.logoFallback = true;
    },
    // 切换语言方法
    changeLang(lang) {
      this.$i18n.locale = saveUserLanguage(lang);
      this.showLangMenu = false;
      this.updateHeaderOffset();
    },
    openGogao(val) { this.goInfo = val; },
    changtanshow() { this.tanshow = !this.tanshow; },
    changGameType(type) {
      this.gameType = type;
      this.selectedVendor = '';
      this.showSearchBox = false;
      this.searchKeyword = '';
      this.ensureVendorSelection();
      this.updateHeaderOffset();
    },
    updateHeaderOffset() {
      this.$nextTick(() => {
        const header = this.$refs.homeHeader;
        if (!header) return;
        const nextOffset = Math.ceil(header.getBoundingClientRect().height) + 6;
        // 忽略异常过小值，防止左侧栏瞬间顶上去
        if (nextOffset < 120) return;
        if (Math.abs(nextOffset - this.headerOffset) > 1) {
          this.headerOffset = nextOffset;
        }
      });
    },
    resolveGameImage(imgValue) {
      if (imgValue === undefined || imgValue === null) return '';

      const imgSrc = String(imgValue).trim();
      if (!imgSrc) return '';

      let resolved = '';
      const embeddedHttpMatch = imgSrc.match(/^\/?uploads\/(https?:\/\/.*)$/i);
      if (embeddedHttpMatch) {
        resolved = embeddedHttpMatch[1];
      } else if (/^https?:\/\//i.test(imgSrc)) {
        resolved = imgSrc;
      } else if (/^\/\//.test(imgSrc)) {
        resolved = window.location.protocol + imgSrc;
      } else {
        const origin = window.location.origin;
        const withoutLeadingSlash = imgSrc.replace(/^\/+/, '');
        const normalizedUploadsPath = withoutLeadingSlash.replace(/^(uploads\/)+/i, 'uploads/');

        if (/^uploads\//i.test(normalizedUploadsPath)) {
          resolved = origin + '/' + normalizedUploadsPath;
        } else if (imgSrc.startsWith('/')) {
          resolved = origin + '/' + withoutLeadingSlash;
        } else {
          resolved = origin + '/uploads/' + normalizedUploadsPath;
        }
      }

      return this.isUsableImageUrl(resolved) ? resolved : '';
    },
    isUsableImageUrl(url) {
      if (!url) return false;
      const path = String(url).trim().split('?')[0].split('#')[0];
      if (!path || /\/uploads\/?$/i.test(path)) return false;
      const file = path.replace(/\/+$/, '').split('/').pop() || '';
      return !!file && !/^uploads$/i.test(file);
    },
    apiLogoSrc(item) {
      return this.resolveGameImage(item && item.api_logo_img);
    },
    hideBrokenApiIcon(event) {
      const wrap = event && event.target && event.target.parentElement;
      if (wrap) wrap.style.display = 'none';
    },
    hideBrokenGameCover(event) {
      const item = event && event.target && event.target.closest('.game-item');
      if (item) item.style.display = 'none';
    },
    onGameCoverLoad(event) {
      const img = event && event.target;
      if (!img) return;
      img.classList.add('is-loaded');
      if (img.parentElement) img.parentElement.classList.add('is-ready');
    },
    looksLikeUrl(value) {
      const text = String(value || '').trim();
      if (!text) return false;
      return /^(https?:)?\/\//i.test(text)
        || /\/uploads\//i.test(text)
        || /^uploads\//i.test(text)
        || /\.(png|jpe?g|gif|webp|svg)(\?|$)/i.test(text);
    },
    getGameDisplayName(item, rawOnly) {
      if (!item) return rawOnly ? 'Game' : this.$t('Game');
      const raw = [item.name, item.game_name, item.title, item.game_code]
        .map(value => String(value == null ? '' : value).trim())
        .find(value => value && !this.looksLikeUrl(value));
      if (!raw) return rawOnly ? 'Game' : this.$t('Game');
      if (rawOnly) return raw;
      const translated = this.$t(raw);
      return this.looksLikeUrl(translated) ? raw : translated;
    },
    getGameImg(item, type) {
      if (!item) return '';

      const mobileImg = this.resolveGameImage(item.mobile_img);
      if (mobileImg) return mobileImg;

      const fallbackFields = [
        'api_logo_img', 'check_yes_img', 'check_no_img', 'header_logo',
        'app_img', 'img', 'image', 'icon', 'cover', 'photo',
        'appimg', 'appimage', 'game_img', 'game_icon', 'game_image',
        'img_url', 'image_url', 'icon_url', 'icon_img',
        'appIcon', 'appImage', 'gameIcon', 'gameImage', 'gameImg',
        'iconUrl', 'imgUrl', 'imageUrl',
        'logo', 'thumb', 'thumbnail', 'pic', 'picture'
      ];
      for (const field of fallbackFields) {
        const fallbackImg = this.resolveGameImage(item[field]);
        if (fallbackImg) return fallbackImg;
      }
      return '';
    },
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      cInput.select();
      document.execCommand('copy');
      this.$parent.showTost(1, this.$t('Copy Successful')); 
    },
    changleftshow() { this.leftshow = !this.leftshow; },
    refreshBalance() {
      let that = this;
      if (that.isRefreshing) return;
      that.isRefreshing = true;
      that.$apiFun.post('/api/balance', {}).then(res => {
        if (res.code == 200 && res.data && res.data.balance !== undefined) {
          let userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
          userInfo.balance = res.data.balance;
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          that.$store.commit('changUserInfo');
        }
      }).catch(err => {}).finally(() => {
        that.isRefreshing = false;
      });
    },
    getBanList() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun.post('/api/bannerList', { type: 2 }).then(res => {
        if (res.code != 200) { that.showTost(0, res.message); }
        if (res.code == 200) {
          const banners = Array.isArray(res.data)
            ? res.data.filter(item => item && item.src)
            : [];
          that.bannerList = banners;
          that.localBanners = banners.length
            ? banners.map(item => item.src)
            : DEFAULT_BANNERS.slice();
          that.current = 0;
          that.updateHeaderOffset();
        }
        that.$parent.hideLoading();
      }).catch(res => {
        that.localBanners = DEFAULT_BANNERS.slice();
        that.$parent.hideLoading();
      });
    },
    homenotice() {
      let that = this;
      that.$apiFun.post('/api/homenotice', {}).then(res => {
        if (res.code != 200) { that.showTost(0, res.message); }
        if (res.code == 200) {
          that.homenoticelis = res.data;
          that.ok = true;
        }
      });
    },
    onChange(index) { this.current = index; },
    changhongbashow() { this.hongbashow = false; },
    startDrag(event) {
      this.isDragging = true;
      this.startX = event.clientX;
      this.startY = event.clientY;
      const tabBar = event.target.closest('.tab-bar');
      if (tabBar) {
        const rect = tabBar.getBoundingClientRect();
        this.initialLeft = rect.left;
        this.initialTop = rect.top;
      }
    },
    drag(event) {
      if (!this.isDragging) return;
      const deltaX = event.clientX - this.startX;
      const deltaY = event.clientY - this.startY;
      const tabBar = event.target.closest('.tab-bar');
      if (tabBar) {
        const parentRect = tabBar.parentElement.getBoundingClientRect();
        const tabRect = tabBar.getBoundingClientRect();
        let newLeft = this.initialLeft + deltaX;
        let newTop = this.initialTop + deltaY;
        newLeft = Math.max(0, Math.min(newLeft, parentRect.width - tabRect.width));
        newTop = Math.max(0, Math.min(newTop, parentRect.height - tabRect.height));
        tabBar.style.position = 'absolute';
        tabBar.style.left = newLeft - parentRect.left + 'px';
        tabBar.style.top = newTop - parentRect.top + 'px';
        tabBar.style.zIndex = '100';
      }
      event.preventDefault();
      event.stopPropagation();
    },
    stopDrag() { this.isDragging = false; },
    toggleSearchBox() {
      this.showSearchBox = !this.showSearchBox;
      if (this.showSearchBox) {
        this.searchKeyword = '';
      }
    },
    closeSearchBox() {
      this.showSearchBox = false;
      this.searchKeyword = '';
    },
    // PG/PGS → PG，CQ9/CQ9S → CQ9，JDB/JDBS → JDB；S 后缀只合并，不单独展示
    normalizeVendorKey(name) {
      const raw = String(name || '').trim().toUpperCase();
      if (!raw) return '';
      if (raw.length > 2 && /S$/.test(raw)) {
        return raw.slice(0, -1);
      }
      return raw;
    },
    getVendorTabs(list) {
      const seen = {};
      const tabs = [];
      (list || []).forEach((game) => {
        const key = this.normalizeVendorKey(game && game.platform_name);
        if (!key || seen[key]) return;
        seen[key] = true;
        tabs.push(key);
      });
      return tabs;
    },
    ensureVendorSelection() {
      const tabs = this.currentVendorTabs;
      if (this.selectedVendor && tabs.indexOf(this.selectedVendor) === -1) {
        this.selectedVendor = '';
      }
    },
    selectVendor(platform) {
      this.selectedVendor = platform ? this.normalizeVendorKey(platform) : '';
    },
  },
  mounted() {
    this.updateHeaderOffset();
    window.addEventListener('resize', this.updateHeaderOffset);
    this.$nextTick(() => {
      const header = this.$refs.homeHeader;
      if (header && typeof ResizeObserver !== 'undefined') {
        this._headerRo = new ResizeObserver(() => {
          this.updateHeaderOffset();
        });
        this._headerRo.observe(header);
      }
      // 图片/字体加载后再量一次，避免首屏高度偏小
      window.setTimeout(() => this.updateHeaderOffset(), 120);
      window.setTimeout(() => this.updateHeaderOffset(), 400);
    });
    // 首次进入首页检查待领取新人彩金
    this.notifyAppCheckRegisterGift();
  },
  updated() {
    this.updateHeaderOffset();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateHeaderOffset);
    if (this._headerRo) {
      this._headerRo.disconnect();
      this._headerRo = null;
    }
  },
};
</script>

<style lang="scss" scoped>
@import '../../../static/css/2d87bbdbffeb4734e5c7.css';

.home-page {
  min-height: 100vh;
  box-sizing: border-box;
  background-color: #000000;
}

.domainModal_content__1nBgc {
  overflow: auto;
  background-color: #1a1a1a; 
  color: #ffffff; 
}

/* ---------------- 顶部 logo & 语言切换区域 ---------------- */
.logo-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between; /* 左右两端对齐 */
  padding: 8px 15px 4px 15px;
  background-color: #000000;
}

.logo-icon {
  height: 28px; 
  width: auto;
  max-width: 160px;
  object-fit: contain;
}

.woa-logo {
  height: 40px;
  max-width: 196px;
}

/* 新增：多语言按钮样式 */
.lang-switch-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 20px;
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.2);
}
.globe-icon {
  color: #fff;
}
.lang-text {
  color: #fff;
  font-size: 13px;
  font-weight: bold;
}

/* 新增：语言菜单底部弹窗样式 */
.lang-menu-content {
  background-color: #1a1a1a;
  color: #fff;
  text-align: center;
}
.lang-title {
  padding: 15px;
  font-size: 14px;
  color: #999;
  border-bottom: 1px solid #333;
}
.lang-item {
  padding: 16px;
  font-size: 16px;
  border-bottom: 1px solid #333;
  transition: all 0.2s;
}
.lang-item:active {
  background-color: #333;
}
.lang-item.active {
  color: #1890ff; /* 选中的语言变蓝 */
  font-weight: bold;
}
.lang-cancel {
  padding: 16px;
  font-size: 16px;
  color: #999;
  margin-top: 6px;
  background-color: #222;
}
/* ---------------- 结束 ---------------- */

.banner-wrapper {
  padding: 0.1rem; 
  padding-top: 0.05rem; 
  background-color: transparent; 
  width: 100%;
  box-sizing: border-box;
}

.my-swipe {
  width: 100%;
  height: 3.8rem;
  border-radius: 8px; 
  overflow: hidden;
}

.banner-img {
  width: 100%;
  height: 100%;
  object-fit: cover; 
}

.swiper-dots {
  display: flex;
  position: absolute;
  right: 15px; 
  bottom: 10px;
  width: 48px;
  height: 24px;
  background-color: rgba(0, 0, 0, 0.6); 
  border-radius: 12px;
  justify-content: center;
  align-items: center;
  
  .num {
    font-size: 12px;
    color: #fff;
    line-height: 24px;
    width: auto;
  }
  .sign {
    margin: 0 2px;
    font-size: 10px;
    color: rgba(255,255,255,0.7);
    line-height: 24px;
    position: static;
    transform: none;
  }
}

.leftbox {
  width: 7.5rem;
  height: 100%;
  background-color: #121212; 
  color: #cf866b;
  .side__main__1NhyG {
    box-sizing: border-box;
    padding: 0 20px;
    h3 {
      font-size: 20px;
      font-weight: 400;
      margin: 0;
      padding-top: 72px;
      color: #ffffff; 
    }
    .side__vip__1dW8w {
      background: url(/static/style/sidebr_vip_card.1ce7485811699286f87aae1827de7acf.png) no-repeat;
      background-size: 100% 100%;
      box-sizing: border-box;
      padding: 20px;
      color: #fff;
      position: relative;
      p {
        color: hsla(0, 0%, 100%, 0.6);
        font-size: 12px;
        margin: 5px 0 0 0;
      }
      .topxs {
        font-size: 16px;
      }
      dd {
        float: right;
        border: 0.02rem solid #fff;
        border-radius: 0.24rem;
        height: 0.48rem;
        line-height: 0.48rem;
        width: 1.88rem;
        text-align: center;
        font-size: 10px;
        position: absolute;
        top: 20px;
        right: 20px;
      }
    }
  }
  ul {
    list-style: none;
    margin-top: 0.36rem;
    li {
      display: block;
      line-height: 0.96rem;
      height: 0.96rem;
      border-bottom: 0.02rem solid #333333; 
      color: #e0e0e0; 
      font-size: 0.28rem;
      padding: 0 0.14rem;
      img {
        width: 0.36rem;
        vertical-align: middle;
        margin: -0.04rem 0.24rem 0 0;
      }
      span {
        float: right;
      }
    }
  }
  .nisd {
    position: absolute;
    width: 4.72rem;
    height: 0.8rem;
    line-height: 0.8rem;
    left: 0.9rem;
    bottom: 1rem;
    background: #333333; 
    border-radius: 0.4rem;
    border: 0;
    color: #ffffff; 
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      vertical-align: middle;
      margin: -0.04rem 0.08rem 0 -0.08rem;
      width: 0.32rem;
    }
  }
}

.gonggao {
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.caosuo {
  color: #cf866b;
  width: 97%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 6px;
  padding-bottom: 6px;
  box-sizing: border-box;
  .lefsg {
    flex: 1;
    min-width: 0;
    .name {
      font-size: 12px;
    }
    .meys {
      display: flex;
      align-items: center;
      margin-top: 10px; 
      .lefs {
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 700;
        color: #ffffff; 
        span {
          font-size: 18px;
          font-weight: 700;
        }
        .imsg {
          margin-left: 8px;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 16px;
            height: 16px;
            &.rotate {
              animation: rotate 1s linear infinite;
            }
          }
        }
        @keyframes rotate {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      }
    }

    &.user-brief {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 6px 8px;
      border-radius: 12px;
      background: linear-gradient(135deg, #fffaf3 0%, #fff2df 100%);
      border: 1px solid #ead1b2;
      box-shadow: 0 2px 8px rgba(128, 79, 36, 0.08);
      cursor: pointer;

      .user-brief-avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        object-fit: cover;
        border: 2px solid #d9a76d;
        flex-shrink: 0;
        background: #fff;
      }

      .user-brief-meta {
        flex: 1;
        min-width: 0;
      }

      .user-brief-top {
        display: flex;
        align-items: center;
        gap: 6px;
        min-width: 0;
      }

      .user-brief-name {
        font-size: 13px;
        font-weight: 700;
        color: #49382b;
        max-width: 72px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .user-brief-vip {
        flex-shrink: 0;
        font-size: 10px;
        font-weight: 700;
        color: #fff;
        background: linear-gradient(135deg, #d4a017, #8f501f);
        border-radius: 8px;
        padding: 1px 6px;
        line-height: 1.4;
      }

      .user-brief-balance {
        margin-top: 3px;
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 14px;
        font-weight: 700;
        color: #8f501f;

        .imsg {
          cursor: pointer;
          display: flex;
          align-items: center;
          img {
            width: 14px;
            height: 14px;
            &.rotate {
              animation: rotate 1s linear infinite;
            }
          }
        }
      }
    }
  }
  
  /* 重写右侧四个图标容器的 CSS 布局 */
  .riggs {
    display: flex;
    justify-content: flex-end;
    align-items: flex-start; /* 顶部对齐，防止文本折行后图标错位 */
    flex-wrap: nowrap;
    padding: 0;
    gap: 2px;
    flex: 1; /* 占据右侧全部剩余空间 */
    min-width: 0;

    .lisImg {
      flex: 1; /* 平均分配宽度 */
      max-width: 65px; /* 控制最大宽度，避免挤占左侧登录区域 */
      min-width: 0;
      text-align: center;
      color: #ffffff; 
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;

      .img-wrapper {
        position: relative;
        display: inline-block;
        width: 32px; /* 固定图标大小 */
        height: 32px;
        margin: 0 auto;
        
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          display: block;
        }
        
        .right-top-label {
          position: absolute;
          top: -2px;
          right: -12px;
          background: linear-gradient(90deg, #ff6b6b, #ee5a6f);
          color: #fff;
          font-size: 10px;
          border-radius: 4px;
          white-space: nowrap;
          z-index: 10;
          transform: scale(0.8); /* 缩小送3%标签，防止撑爆 */
        }
      }
      
      > img {
        width: 32px;
        height: 32px;
        object-fit: contain;
        display: block;
        margin: 0 auto;
      }
      
      .link-icon {
        width: 32px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      
      .icon-text {
        font-size: 10px; /* 缩小字号兼容多语言 */
        line-height: 1.15;
        margin-top: 4px;
        width: 100%;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        min-height: 12px;
      }
    }
  }
}

.xiding {
  background-color: #000000; 
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;
  transition: top 0.3s ease;
}

.balance-wrapper {
  display: flex;
  align-items: center;
  margin-top: 10px; 
  flex: 0 0 auto;
  max-width: 46%;
  min-width: 0;
}


/* ----- 完美还原原来图片质感的多语言登录注册按钮 ----- */
.login-wrapper {
  display: flex;
  gap: 6px; /* 两个按钮的间距 */
  flex-shrink: 0;
  align-items: center;
  max-width: 100%;

  .button {
    height: 0.65rem;
    line-height: 0.65rem;
    padding: 0 8px;
    border-radius: 6px;
    font-size: 0.28rem !important;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    min-width: 1.28rem; /* 保证英文单词不被挤扁 */
    max-width: 1.65rem;
    white-space: nowrap; 
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    transition: all 0.2s;
  }

  /* 还原原来的 "注册" 白色按钮外观 */
  .custom-reg-btn {
    background-color: #ffffff;
    color: #555555;
    border: 1px solid #dcdcdc;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05); /* 微微的立体阴影 */
  }
  .custom-reg-btn:active {
    background-color: #f5f5f5;
  }

  /* 还原原来的 "登录" 蓝色渐变按钮外观 */
  .custom-login-btn {
    background: linear-gradient(180deg, #60a5fa 0%, #1890ff 100%); /* 仿制原图的蓝底渐变 */
    color: #ffffff;
    border: none;
    box-shadow: 0 2px 4px rgba(24, 144, 255, 0.3); /* 蓝色立体发光阴影 */
  }
  .custom-login-btn:active {
    background: linear-gradient(180deg, #3b82f6 0%, #096dd9 100%);
  }
}

.gameBoxs {
  background-color: #000000; 
  box-sizing: border-box;
  color: #e0e0e0; 
  height: auto;
  min-height: 608px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 4px;

  /* 3. 左侧分类：sticky 跟随内容，避免 fixed 错误 top 顶上去 */
  .lfst {
    width: 1.35rem;
    flex: 0 0 1.35rem;
    border-radius: 16px;
    border-top: none;
    position: sticky;
    align-self: flex-start;
    left: auto;
    bottom: auto;
    overflow-y: auto;
    overflow-x: hidden;
    z-index: 20;
    transition: none;
    transform: none;
    will-change: auto;
    -webkit-overflow-scrolling: touch;
    box-sizing: border-box;
    padding: 4px 2px;
    
    &::-webkit-scrollbar {
      display: none;
    }
    
    .ls.active {
      color: #1989fa; 
      background-image: url(/static/style/gameicon_1773179136_g100pWLyRS.png);
      span { color: #1989fa; }
    }
    
    .ls {
      text-align: center;
      border-radius: 12px;
      padding: 6px 2px 5px;
      background-image: url(/static/style/bbbb.png);
      background-size: 100% 100% !important;
      background-repeat: no-repeat !important;
      background-position: center !important;
      transition: none !important;
      animation: none !important;
      width: 100% !important;
      box-shadow: none !important;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      min-height: 62px;
      margin-bottom: 4px;
      
      img {
        width: 30px;
        display: block;
        margin: 0 auto 3px;
      }

      .side-icon-wrap {
        width: 42px;
        height: 42px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto 4px;
        background: transparent;
        border: none;
        box-shadow: none;
        overflow: visible;
      }

      .side-icon-img {
        width: 42px !important;
        height: 42px !important;
        margin: 0 !important;
        display: block;
        object-fit: contain;
      }

      span {
        font-size: 11px;
        display: block;
        color: #666666; 
        font-weight: 500;
        line-height: 1.1;
        white-space: normal;
        word-wrap: break-word;
        width: 100%;
      }
    }

    .ls.active .side-icon-wrap {
      background: transparent;
      border: none;
      box-shadow: 0 0 0 2px #d9a76d;
      transform: scale(1.02);
    }
  }

  /* 1. 右侧内容与左侧并排，不再靠 margin 硬挤 */
  .content-area {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-left: 0.08rem;
    min-width: 0;
  }

  .rigts {
    box-sizing: border-box;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px 6px;
    align-items: start;
    align-content: start;
    position: relative;
    padding: 0 5px 70px;
    
    .game-item {
      position: relative;
      width: 100%;
      min-width: 0;
      margin-top: 0;
      text-align: center;
      cursor: pointer;
      
      .game-icon-container {
        position: relative;
        display: block;
        width: 100%;
        height: 0;
        padding-bottom: 100%;
        border-radius: 10px;
        overflow: hidden;
        background: linear-gradient(110deg, #2b241c 8%, #4a3d2c 36%, #d4b07a 50%, #4a3d2c 64%, #2b241c 92%);
        background-size: 220% 100%;
        animation: gameCoverShimmer 1.35s ease-in-out infinite;

        &.is-ready {
          animation: none;
          background: #1b1b1b;
        }

        > img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          margin: 0;
          border-radius: 0;
          opacity: 0;
          transition: opacity 0.28s ease;
          &.is-loaded {
            opacity: 1;
          }
        }
        .api-icon {
          position: absolute;
          top: 0;
          right: 0;
          width: 36px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10;
          img {
            width: 30px;
            object-fit: contain;
            border-radius: 0 10px 0 0;
          }
        }
      }
      .game-name {
        position: static;
        width: 100%;
        margin: 6px 0 0;
        padding: 0 2px;
        text-align: center;
        font-size: 12px;
        font-weight: 600;
        line-height: 1.35;
        letter-spacing: 0.01em;
        color: #5a3a22;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        word-break: break-word;
        background: none;
        z-index: auto;
        pointer-events: none;
      }
    }
    
    &.hot-grid,
    &.three-column {
      grid-template-columns: repeat(3, 1fr);
      padding: 6px 5px 70px;
    }
    
    &.single-column {
      grid-template-columns: 1fr;
    }
    
    .game-item.full-width {
      grid-column: 1 / -1;
    }
  }
}

@keyframes gameCoverShimmer {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}

/* 2. 恢复顶部 Tab 栏的间距 */
.top-tab-bar {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #000000; 
  padding: 4px 8px;
  margin: 0;
  z-index: 999;
  
  .game-type-tabs {
    display: flex;
    gap: 5px;
    overflow-x: auto;
    flex: 1;
    scrollbar-width: none;
    &::-webkit-scrollbar { display: none; }
    
    .game-type-tab {
      padding: 5px 20px;
      border-radius: 4px;
      font-size: 14px;
      cursor: pointer;
      white-space: nowrap;
      background-image: url(/static/style/ddh.png);
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      color: #333333; 
      border: none;
      outline: none;
      transition: all 0.2s ease;
      display: inline-flex;
      align-items: center;
      justify-content: center;

      &.active {
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIcAAAA5CAMAAAAr+cg9AAAAYFBMVEUAAABjt/1ks/xltvpmtv9muf1mt/4LZ+ZhtPw7kfBmt/xitPsDX+FHnPQPaeQNaOQQaeQdd+jR5P/Z6f/G3f/p8v/w9v/g7P/L4P/k7/8CXeFbl+z1+f9xpfAzfeeRuvXavtWnAAAAEnRSTlMAMxBGHltqJBaXJk/lfavGfWGnzvn6AAAEK0lEQVRYw82Yi3qiMBCFF1DLCoKLyGUo+P5vuTMc4gGqlN0udU/CTGYysf+XxNb647/X2xb6Q4RzEss2SpPzSpjwnIqq65p/r64TVfzrbQVFrAy3/L1430b5zViST0iMoq2LonhXkAJ9cEigPcswixHbYPogazvdk6XNSJWiLFbpvfiCsnZpS95i6bLie5Tplrw9xWjvdVc65uj1sTbXx1la6tqbRmLvGcYVKvBoZ4K5wRcFvA1Y1of9DKxDmkRY1XJH5hhfEFFW6xGInxLj29RI6s/fsNJdr7U2qJ42yzDdi2mXqh8vdY7LuKqT8wTE11PJa+g6OPN9NdwgBpyGn9c4ixdgOUDgqtnJ+Im09QOVHC7OjYMVS1jdSuKPMDyRsqy1meXIOlQjYqYPucAMJzkBw1ekQb+IeP54O27lc9ULc18tb0c3xA9jycrygq7NLHSBYcwhZXk6PIwuzs9KYTK9Ib7j+CXN5aF09TqVf13SyC/HEeqxWOHHZtmV7fOCx9mbJCFA/F0sVc+WXb5flcQ7cIQ76TRBigwdCXo0N+8S7FNZigVcx7WDRI4hOCLp7qVcy0VMPIBknmtZMEVgHXrfOglCvz8WvabZi6QgelF3jqNFDkb79OHkPFjIcWHf6c2Na1s5DxzngaMaDB84Ts6DpVxFzxdGZvDkCO16HHuOCs3VM5wNGKxvS2uM4wgOux+cAa05Ng77KXXjKib6IHsKW83T1vV+DByRNNXr1N05ApGqyvNKDTsfncldGgGMy7PDYciEG1o0BOOwE2/g8GLJXyeJ7xyJ3PJX6SYpOPydd5Imf5UaOXtHHxyRvO5gRAJvB45jkEibv0atpI5DL8hJpOrFNwuHuOSco2EpY2eZYOH4zYiWiRyCIz6AKEeUSvvhV18Fixh5s24OI0RulXvQxm682tww0O2I+muKCxIcRPLFPyPV00mKvE9mPii37cCx4GCiRLqMnxz45xKheuY4AT+esCq3hAV9hiEXdpLYdiiHKdQN2cfSLn3IzS6rxLI1aiXeBzgWHIxuyAkg5XOU6Xi5qFyJcYqCox0LNyQ6ibTlsi4cfr2ybkVO3A53Q4K9geD/x2mbDNXOMoycMY0XjqpHiTvG+B9c25C9Hk2Xj79A4JcN484MEsi4HMeIaLWzpOr0UPYR3ixU6EDkdv0G6dVwGJPtsJMxkEMi0t2yQjV8q4WhizHgnD00Vw5Zy+Td2ZFIcjAMnAp1BzmlWtMoylbKbo2IpKcnGA7ESGJRdc0W6sSUKMUDDO4ISA4/FWUrxenPAyhwN0jCHdnZlhiJ6vRzC50Opn1km2EYjwQQL8CebCTsReAtYYxIFGUjRUsUZDESQ1mpiH6lPIUwimUMkCjK0dtGR4UgxacoyvKvdYQLCfEZiT1QaB0NAfpCo6NBc8JPWIvy3foNJmnskhJAWk4AAAAASUVORK5CYII=);
        color: #ffffff; 
        font-weight: bold;
      }
    }
  }
  
  .search-icon {
    display: flex;
    align-items: center;
    .search-img {
      width: 20px;
      height: 20px;
      cursor: pointer;
      background: #1a1a1a;
      border: 0.04415rem solid #444;
      border-right: none;
      transition-duration: .15s;
      padding-left: 0.14493rem;
      padding-right: 0.28986rem;
      border-radius: 15px 0 0 15px;
      transform: translateY(-1px);
    }
  }
  
  .search-box {
    position: absolute;
    left: 0;
    right: 0;
    padding: 3px;
    display: flex;
    background: #1a1a1a; 
    border-radius: 15px 0 0 15px;
    
    .search-input-wrapper {
      flex: 1;
      display: flex;
      align-items: center;
      .search-img-inside {
        position: absolute;
        left: 10px;
        width: 16px;
        height: 16px;
        z-index: 1;
      }
      .search-input-with-icon {
        flex: 1;
        padding: 4px 4px 4px 32px;
        border-radius: 20px;
        font-size: 14px;
        background: #333333; 
        color: #ffffff; 
        border: 0.02415rem solid #555555;
        border-right: none;
        &::placeholder { color: #999999; }
      }
    }
    
    .search-close {
      margin-left: -30px;
      cursor: pointer;
      font-size: 24px;
      color: #999;
    }
  }
}

/* 强制隐藏编译后因路径丢失而变成“口”的字体图标 */
.riggs .lisImg .icon-text::before,
.riggs .lisImg .icon-text::after,
.riggs .lisImg::before,
.riggs .lisImg::after {
  display: none !important;
  content: none !important;
}

.realbet-content,
.sport-content {
  box-sizing: border-box !important;
  display: grid !important;
  gap: 0.1rem !important;
  align-content: start !important;
  position: relative !important;
  padding: 0 5px 70px !important;
  grid-template-columns: 1fr !important;
}

.realbet-icon-container,
.sport-icon-container {
  width: 100% !important;
  height: 120px !important;
  min-width: 100% !important;
  max-width: 100% !important;
  min-height: 120px !important;
  max-height: 120px !important;
  overflow: hidden !important;
  border-radius: 8px !important;
  position: relative !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-sizing: border-box !important;
  flex-shrink: 0 !important;

  img {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
    border-radius: 22px !important;
    display: block !important;
    padding: 8px !important;
    box-sizing: border-box !important;
  }
}

.login-modal-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  
  .login-modal-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
  }
  
  .login-modal-content {
    position: relative;
    z-index: 1001;
    width: 90%;
    max-width: 400px;
    background: #1a1a1a; 
    border-radius: 12px;
    overflow: hidden;
  }
}

/* White + warm gold theme (reference layout) */
.home-page {
  background: #ffffff;
  color: #3d332b;
}

.xiding,
.logo-wrapper {
  background-color: #ffffff;
}

.xiding {
  box-shadow: 0 2px 10px rgba(119, 75, 36, 0.08);
}

.lang-switch-btn {
  background: #fff8ef;
  border-color: #dec7aa;
}

.globe-icon,
.lang-text {
  color: #8e562a;
}

.caosuo {
  color: #9d622f;

  .lefsg .meys .lefs,
  .riggs .lisImg {
    color: #49382b;
  }

  .lefsg.user-brief {
    .user-brief-name {
      color: #49382b;
    }
    .user-brief-balance {
      color: #8f501f;
    }
  }
}

.login-wrapper {
  .custom-reg-btn {
    background: #ffffff;
    color: #8e562a;
    border: 1px solid #d9b98f;
    box-shadow: 0 2px 7px rgba(128, 79, 36, 0.1);
  }

  .custom-login-btn {
    background: linear-gradient(135deg, #b87333 0%, #8f501f 100%);
    color: #ffffff;
    border: 1px solid #a55f27;
    box-shadow: 0 3px 8px rgba(143, 80, 31, 0.22);
  }

  .custom-login-btn:active {
    background: #7f461c;
  }
}

.gameBoxs {
  background: #ffffff;
  color: #49382b;

  .lfst {
    background: #fff8ef;
    border: 1px solid #f0dfca;
    box-shadow: 0 3px 12px rgba(128, 79, 36, 0.08);
    width: 1.35rem;
    flex: 0 0 1.35rem;
    position: sticky;
    align-self: flex-start;
    border-radius: 14px;
    padding: 6px 3px;

    .ls {
      background-image: none;
      background-color: transparent;
      border: 1px solid transparent;
      border-radius: 12px;
      min-height: 64px;
    }

    .ls.active {
      color: #9d5b25;
      background-image: none;
      background-color: #fff2df;
      border-color: #e0b57a;

      span {
        color: #9d5b25;
        font-weight: 700;
      }

      .side-icon-wrap {
        box-shadow: 0 0 0 2px #d9a76d;
      }
    }
  }

  .content-area {
    margin-left: 0.08rem;
  }
}

.top-tab-bar {
  background: #ffffff;
  border-bottom: 1px solid #f1e3d2;

  .game-type-tabs .game-type-tab {
    background-image: none;
    background-color: #fff8ef;
    color: #775137;
    border: 1px solid #ead1b2;

    &.active {
      background-image: none;
      background: linear-gradient(135deg, #b87333, #8f501f);
      border-color: #9d5b25;
      color: #ffffff;
    }
  }

  .search-icon .search-img {
    background: #fff8ef;
    border-color: #ead1b2;
  }

  .search-box {
    background: #ffffff;

    .search-input-wrapper .search-input-with-icon {
      background: #fffaf5;
      color: #49382b;
      border-color: #ead1b2;
    }
  }
}

.login-modal-wrapper .login-modal-content {
  background: #ffffff;
}

</style>



// WEBPACK FOOTER //
// src/components/mode/index.vue